import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import search from "../../Assets/Projects/search.png";
import groco from "../../Assets/Projects/groco.png";
import todo from "../../Assets/Projects/img-todo.png";
import weather from "../../Assets/Projects/weather.png";
import college from "../../Assets/Projects/college.png";
import memory from "../../Assets/Projects/memory.png";
import aiComp from "../../Assets/Projects/ai-component-genrator.png";
function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aiComp}
              isBlog={false}
              title="🚀 AI Website Generator"
              description="An AI-powered, fully responsive web application built using React.js and Tailwind CSS. This tool allows users to generate complete websites (Portfolio, Landing Page, Todo App, Admin Dashboard, etc.) by selecting their preferred framework/technology and providing a short description. The platform instantly generates production-ready code and also provides a live working preview to test the website’s functionality. Tech Stack: React.js, Tailwind CSS Key Features: Multi-framework support, Instant code generation, Live preview, Fully responsive."
              demoLink="https://ai-react-comp-gen.netlify.app/"
            />
          </Col>
            
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={college}
              isBlog={false}
              title="Govt. Polytechnic Colleg Betul"
              description="A fully dynamic college website developed using Node.js, Express.js, MongoDB, EJS, HTML, CSS, Tailwind, and JavaScript. It incorporates Cloudinary for image management, Multer for file uploads, JWT authentication for secure user access, and Nodemailer for email functionality. This project showcases my expertise in full-stack development, integrating multiple technologies to create a robust and dynamic web application."
              demoLink="https://gpcbetulm.onrender.com"
            />
          </Col>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="Editor.io"
              description="A full-stack To-Do app built with Node.js, Express.js, MongoDB, EJS, HTML, CSS, and JavaScript. It features JWT authentication and cookie management for secure sign-in, sign-up, and profile pages. Users can save and manage their daily tasks efficiently. This project demonstrates my skills in backend development, database integration, and user authentication."
              ghLink="https://github.com/KaranGhorse/todoDeployAgain"
              demoLink="https://todoapp-hfxd.onrender.com"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={weather}
              isBlog={false}
              title="Weather App"
              description="A dynamic weather app built with HTML, CSS, and JavaScript. It fetches real-time weather data to display current temperature, wind speed, and humidity. The app features weather-specific icons (sun, clouds, rain) that update according to the conditions. This project highlights my skills in front-end development and API integration."
              ghLink="https://github.com/KaranGhorse/weatherapp"
              demoLink="https://karanghorse.github.io/weatherapp/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={memory}
              isBlog={false}
              title="Memory Game"
              description="A fun and interactive memory game developed using HTML, CSS, and JavaScript. Players match pairs of identical images, testing and improving their memory skills. This project showcases my abilities in front-end development, game logic implementation, and responsive design."
              ghLink="https://github.com/KaranGhorse/memorygame"
              demoLink="https://karanghorse.github.io/memorygame/"
            />
          </Col>

          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={search}
              isBlog={false}
              title="Image Search Engine"
              description='A front-end web application built using HTML, CSS, and JavaScript that utilizes an API to search and display images. The app features a search box where users can input image names, and it loads 10 images at a time with a "Load More" button to fetch additional images. This project demonstrates my skills in front-end development and API integration to create a seamless user experience.'
              ghLink="https://github.com/KaranGhorse/Searchimage"
              demoLink="https://karanghorse.github.io/Searchimage/"
            />
          </Col>

          

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={groco}
              isBlog={false}
              title="Grocery Shopping Web"
              description="A responsive and user-friendly website designed for grocery shopping, created solely with HTML, CSS, and JavaScript. This frontend web application ensures seamless usability across various devices, providing an optimal experience for users. With a focus on simplicity and intuitive design, this project showcases my skills in front-end development and user interface design."
              ghLink="https://github.com/KaranGhorse/Groco"
              demoLink="https://karanghorse.github.io/Groco/"  
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
